import { View, Map, Overlay, Feature } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import { XYZ, OSM, Source } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import { FitOptions } from 'ol/View';
import { ScaleLine } from 'ol/control';
import { koCenter, koExt } from './util';
import * as interactions from 'ol/interaction';
import WebGLTileLayer from 'ol/layer/WebGLTile.js';
import ImageTileSource from 'ol/source/TileImage';
import { sourcesFromTileGrid } from 'ol/source.js';
import { myKey } from '../service/common';
import { Point } from 'ol/geom';
import { transform } from 'ol/proj';

// import Source from 'ol/source/ImageTile.js';

//코어를 담당하는 mapInstance Viewer객체
//Viewr객체의 기능
class OlCore {
  private SATELLITE_URL = 'http://mt0.google.com/vt/lyrs=s&hl=ko&x={x}&y={y}&z={z}';

  private VWORLD_SATELLITE_URL = `http://api.vworld.kr/req/wmts/1.0.0/${myKey}/Satellite/{z}/{y}/{x}.jpeg`;
  private VWORLD_BASE = `http://api.vworld.kr/req/wmts/1.0.0/${myKey}/Base/{z}/{y}/{x}.png`;
  private VWORLD_HYBRID = `http://api.vworld.kr/req/wmts/1.0.0/${myKey}/Hybrid/{z}/{y}/{x}.png`;

  private GOOGLE_ROADS = 'http://mt0.google.com/vt/lyrs=h&hl=ko&x={x}&y={y}&z={z}';
  private GOOGLE_STANDARD = 'http://mt0.google.com/vt/lyrs=m&hl=ko&x={x}&y={y}&z={z}';
  private GOOGLE_TERRAIN = 'http://mt0.google.com/vt/lyrs=p&hl=ko&x={x}&y={y}&z={z}';
  private GOOGLE_SAR = 'http://mt0.google.com/vt/lyrs=r&hl=ko&x={x}&y={y}&z={z}'; //somehow altered roadmap
  private GOOGLE_HYBRID = 'http://mt0.google.com/vt/lyrs=y&hl=ko&x={x}&y={y}&z={z}';

  public Pyramid_url = `http://test.digitaltwinx.kr/layer/m-map/{z}/{x}/{y}.png`;
  //  public Pyramid_url = `https://tile.openstreetmap.org/{z}/{x}/{y}.png`;
  //   public Pyramid_url = 'file:///Users/yoon/mapping/{z}/{x}/{y}.png';
  public PyramidMapLayer = new TileLayer({
    source: new XYZ({
      url: this.Pyramid_url,
      crossOrigin: 'anonymous',
    }),
    properties: { name: 'PyramidMapLayer' },
    zIndex: 2,
    preload: Infinity,
  });

  public googleMapSource = new XYZ({ url: this.SATELLITE_URL });
  public vWorldSatelliteSource = new XYZ({ url: this.VWORLD_SATELLITE_URL });
  public vWorldBaseSource = new XYZ({ url: this.VWORLD_BASE });
  public vWorldHybridSource = new XYZ({ url: this.VWORLD_HYBRID });

  public roadMapSource = new XYZ({ url: this.GOOGLE_ROADS });
  public standardMapSource = new XYZ({ url: this.GOOGLE_STANDARD });
  public terrainMapSource = new XYZ({ url: this.GOOGLE_TERRAIN });
  public sarMapSource = new XYZ({ url: this.GOOGLE_SAR });
  public hybridMapSource = new XYZ({ url: this.GOOGLE_HYBRID });
  // public osmMapSource = new OSM();

  // 구글 위성 지도
  public googleMapLayer = new TileLayer({
    source: this.googleMapSource,
    properties: { name: 'google-map-satellite' },
    zIndex: 1,
    preload: Infinity,
  });

  //vworld 지도
  public vworldMapLayer = new TileLayer({
    source: this.vWorldSatelliteSource,
    properties: { name: 'vworld-map-satellite' },
    zIndex: 1,
    preload: Infinity,
  });

  // 기본 2D 지도
  public osmMapLayer = new TileLayer({
    source: this.vWorldBaseSource,
    properties: { name: 'osm-map' },
    zIndex: 1,
    preload: Infinity,
  });

  public mapInstance: Map;
  public viewer: View;
  public localTileLayer: any;

  //지도 초기화
  constructor() {
    this.mapInstance = new Map({
      target: 'mapContainer',
      layers: [
        this.vworldMapLayer,
        //   this.PyramidMapLayer,
      ],
      pixelRatio: window.devicePixelRatio || 1, // ✔ 픽셀 비율 자동 조정
      view: new View({
        center: koCenter,
        // extent: koExt,
        zoom: 7.751621106338325,
        // maxZoom: 20,
        projection: 'EPSG:5186',
        // constrainResolution: true, // ✔ 해상도 보정
      }),
      interactions: interactions.defaults({ doubleClickZoom: false }),
    });

    this.viewer = this.mapInstance.getView();
    this.mapInstance.addControl(
      new ScaleLine({
        target: document.getElementById('scaleBar') as any,
      }),
    );
    // this.mapInstance.on('moveend', (e) => {
    //   console.log(e);
    // });
  }

  // 정사영상 레이어 추가
  public initializeMap(tileMap) {
    this.mapInstance.removeLayer(this.localTileLayer); // 지도에서 기존 레이어 삭제
    this.localTileLayer = new TileLayer({
      source: new XYZ({
        tileUrlFunction: (tileCoord) => {
          const [zoom, x, y] = tileCoord;
          if (tileMap[zoom] && tileMap[zoom][x] && tileMap[zoom][x][y]) {
            return tileMap[zoom][x][y]; // Base64 URL 반환
          }
          return null; // 타일이 없으면 null 반환
        },
      }),
      zIndex: 2,
    });
    this.mapInstance.addLayer(this.localTileLayer);
  }

  // 정사영상 레이어 visible값
  public getTileLayerVisible() {
    if (this.localTileLayer) {
      return this.localTileLayer?.getVisible();
    }
  }
  // 정사영상 레이어 토글
  public localTileLayerToggle(bool) {
    if (this.localTileLayer) {
      // this.localTileLayer?.setVisible(!this.localTileLayer?.getVisible());
      this.localTileLayer?.setVisible(bool);
    }
  }

  // 정사영상 레이어 삭제
  public removeLocalTileLayer() {
    this.mapInstance.removeLayer(this.localTileLayer); // 지도에서 레이어 삭제
    this.localTileLayer = null;
  }

  //해당 레이어로 화면이동
  public moveToLayer(layer?: VectorLayer<VectorSource>, option?: FitOptions) {
    if (layer?.getSource()?.getExtent()[0] !== Infinity) {
      layer && this.viewer.fit(layer.getSource()?.getExtent() || [], option);
    }
  }

  public moveToFeature(feature?: Feature, option?: FitOptions) {
    if ((feature?.getGeometry() as any).getExtent() !== Infinity) {
      feature && this.viewer.fit(feature.getGeometry()?.getExtent() || [], option);
    }
  }
  public getMapInstance() {
    return this.mapInstance;
  }

  //지도 이동 후 스케일바 조절
  public onMoveEnd(callback: () => void) {
    this.mapInstance.on('moveend', () => {
      callback();
    });
  }

  public getOverlay(id: string) {
    return this.mapInstance
      .getOverlays()
      .getArray()
      .find((i: Overlay) => i.getOptions().id === id);
  }

  public mapChange(source: XYZ | OSM) {
    this.mapInstance.getAllLayers()[0].setSource(source);
  }
  public getCenter(extent: number[]) {
    const num1 = (extent[0] + extent[2]) / 2;
    const num2 = (extent[1] + extent[3]) / 2;
    return [num1, num2];
  }
  // 해당 중심좌표로 화면 이동
  public moveToCoord(coord: number[]) {
    const size = this.mapInstance.getSize() || [];
    const position = [size[0] / 2, size[1] / 2];

    this.viewer.centerOn(coord, size, position);
  }

  public moveToPointCoord(coord: number[]) {
    this.mapInstance.getView().fit(new Point(coord), { maxZoom: 18 });
  }
  //해당 레이어로 화면이동
  public toggleQuickToLayer(layerList) {
    layerList.map((i) => {
      if (i.active) {
        i.layerId.map((j) => {
          this.mapInstance
            .getAllLayers()
            .find((i) => i.get('id') === j)
            ?.setVisible(true);
        });
      } else {
        i.layerId.map((j) => {
          this.mapInstance
            .getAllLayers()
            .find((i) => i.get('id') === j)
            ?.setVisible(false);
        });
      }
    });
  }

  public toggleProjection(targetEpsg: 'EPSG:5186' | 'EPSG:5174') {
    const currentView = this.mapInstance.getView();
    const currentProjection = currentView.getProjection().getCode();

    if (currentProjection === targetEpsg) return;

    const center = currentView.getCenter();
    const zoom = currentView.getZoom();

    // 현재 중심좌표를 새 좌표계로 변환
    const newCenter = transform(center!, currentProjection, targetEpsg);

    const newView = new View({
      projection: targetEpsg,
      center: newCenter,
      zoom: zoom,
    });

    this.mapInstance.setView(newView);
    this.viewer = newView;
  }
}

export default OlCore;
